var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1717 12.1096L9.58831 8.15277C9.81568 7.94908 10.1843 7.94907 10.4117 8.15277L14.8283 12.1096C15.1951 12.4382 14.9353 13 14.4166 13H13.5V17C13.5 17.5523 13.0523 18 12.5 18H7.5C6.94772 18 6.5 17.5523 6.5 17V13H5.58339C5.06469 13 4.80492 12.4382 5.1717 12.1096Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2595 4.25C16.3871 2.57189 17.7892 1.25 19.5 1.25C21.2108 1.25 22.6129 2.57189 22.7405 4.25H22.75V19C22.75 20.5188 21.5188 21.75 20 21.75H4C2.48122 21.75 1.25 20.5188 1.25 19V7C1.25 5.48122 2.48122 4.25 4 4.25H16.2595ZM21.25 15.5C21.25 14.5335 20.4665 13.75 19.5 13.75C18.5335 13.75 17.75 14.5335 17.75 15.5C17.75 15.9142 17.4142 16.25 17 16.25C16.5858 16.25 16.25 15.9142 16.25 15.5V5.75H4C3.30964 5.75 2.75 6.30964 2.75 7V19C2.75 19.6904 3.30964 20.25 4 20.25H20C20.6904 20.25 21.25 19.6904 21.25 19V15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousePlan);
export default __webpack_public_path__ + "static/media/house-plan.e003fdc07fab0d7be02095a4fedf47bf.svg";
export { ForwardRef as ReactComponent };